import { HeartPlus } from "lucide-react";

const NoData = ({ hasStudents, hasActivity, chosenStudent, onboardingNoDataId }) => {
  // Normalize booleans in case callers pass numbers/undefined
  const hasStudentsBool = !!hasStudents;
  const hasActivityBool = !!hasActivity;

  if (!hasStudentsBool) {
    return (
      <div
        className="flex items-center justify-center gap-2 text-400 bg-white shadow border-2 border-dotted rounded p-8 mt-3"
        data-onboarding-no-data={onboardingNoDataId || "generic"}
        data-onboarding-no-data-type="no-students"
      >
        <HeartPlus className="w-10 h-10 text-[#2D374840]" />
        <span className="text-[16px]">
          No students found. Add students to see their wellness data below.
        </span>
      </div>
    );
  }

  if (
    !hasActivityBool &&
    (chosenStudent === "All Students" || chosenStudent === "Choose Student")
  ) {
    return (
      <div
        className="flex items-center justify-center gap-2 text-400 bg-white shadow-sm border-2 border-dotted rounded p-8 mt-3"
        data-onboarding-no-data={onboardingNoDataId || "generic"}
        data-onboarding-no-data-type="no-activity"
      >
        <HeartPlus className="w-10 h-10 text-[#2D374840]" />
        <span className="text-[16px]">
          No activity data found for your current selection. Try expanding your
          time filter to view past data.
        </span>
      </div>
    );
  }

  return null;
};

export default NoData;
